import { useMutation } from '@connectrpc/connect-query'
import { withdrawBiddingSpotBids } from '@ebalance/proto/bffuser/v1/bidding_spot_service-BiddingSpotService_connectquery'

import { useWorkflowCaseScopedMutation } from '~/hooks/bidding/useWorkflowCaseScopedMutation'
import type { InvalidatingMutationResultFor } from '~/hooks/useInvalidatingMutation'

/**
 * 入札中の札の一括取下 mutation hook (AC-BSP-116)。 対象は札 (id) で、 楽観ロックの基準は
 * 札ごとに、 その札が属する申請セットの updated_at。
 *
 * 札ごとの成否は応答の `results` にあり、 RPC が成功しても受け付けられなかった札がありうる。
 * 受け付けた札は JEPX への取消送信が成立するまで「取下処理中」 に留まる (AC-BSP-057b)。
 *
 * invalidate を持たない: 一覧を読み直すかは結果で決まる (内容だけ先に更新されていた札がある時は、
 * 自動では読み直さず「再読み込み」 を待つ。 AC-BSP-116)。 呼び出し元の `useBulkWithdrawBidding` が
 * 決める。
 */
export const useWithdrawBiddingSpotBids = (): InvalidatingMutationResultFor<
  typeof withdrawBiddingSpotBids
> => useWorkflowCaseScopedMutation(useMutation(withdrawBiddingSpotBids))
